import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import PhoneNumber from "../models/PhoneNumber";
import ListWrapper from "../utils/ListWrapper";
import Relative from "../models/Relative";
import TextView from "./TextView";
import CollapseView from "./CollapseView";
import ReadTextView from "./ReadTextView";
import { BuildContext } from "../classes/BuildContext";

export interface ResponseRelativesViewProps extends BaseUIProps {
  key?: string;
  obj: Array<Relative>;
  _objHash?: number;
}

class _ResponseRelativesViewState extends ObservableComponent<ResponseRelativesViewProps> {
  static defaultProps = { obj: [] };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: ResponseRelativesViewProps) {
    super(props);

    this.initState();
  }
  public get obj(): Array<Relative> {
    return this.props.obj;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.subscribeToList(this.obj, "obj");

    this.updateSyncCollProperty("obj", this.props.obj);

    this.on(
      [
        "obj",
        "obj.dob",
        "obj.emails",
        "obj.firstName",
        "obj.lastName",
        "obj.middleName",
        "obj.phoneNumbers",
        "obj.phoneNumbers.location",
        "obj.phoneNumbers.phoneNumber",
        "obj.phoneNumbers.phoneType",
        "obj.relation",
      ],
      this.rebuild
    );
  }
  public componentDidUpdate(prevProps: ResponseRelativesViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.obj !== this.props.obj) {
      this.updateObservableColl("obj", prevProps.obj, this.props.obj);

      this.fire("obj", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      mainAxisAlignment: ui.MainAxisAlignment.start,
      crossAxisAlignment: ui.CrossAxisAlignment.start,
      children: [
        TextView({
          data: "Relatives :",
          style: new ui.TextStyle({
            fontSize: 16,
            fontWeight: ui.FontWeight.bold,
          }),
          className: "x580 hc",
          key: "0",
        }),
        this.obj.expand((item) => [
          ui.Container({
            margin: ui.EdgeInsets.symmetric({
              horizontal: 0.0,
              vertical: 5.0,
              transitions: new Map(),
            }),
            child: CollapseView({
              title:
                (item?.firstName ?? "") +
                " " +
                (item?.middleName ?? "") +
                " " +
                (item?.lastName ?? ""),
              subTitle: item?.relation ?? "",
              content: ui.Column({
                crossAxisAlignment: ui.CrossAxisAlignment.start,
                children: [
                  ReadTextView({
                    title: "Date of Birth",
                    value: item?.dob ?? "",
                    className: "x5fd hc h",
                    key: "0",
                  }),
                  ui.Row({
                    mainAxisAlignment: ui.MainAxisAlignment.start,
                    crossAxisAlignment: ui.CrossAxisAlignment.start,
                    children: [
                      ui.Column({
                        mainAxisAlignment: ui.MainAxisAlignment.start,
                        crossAxisAlignment: ui.CrossAxisAlignment.start,
                        children: [
                          ui.Table({
                            defaultColumnWidth: new ui.FlexColumnWidth(1),
                            children: [
                              ui.TableRow({
                                children: [
                                  ui.TableCell({
                                    verticalAlignment:
                                      ui.TableCellVerticalAlignment.middle,
                                    child: TextView({
                                      data: "Phone Number",
                                      style: new ui.TextStyle({
                                        fontFamily:
                                          cStyle.tTextViewTableHeaderFontFamilyOn,
                                        color:
                                          cStyle.tTextViewTableHeaderColorOn,
                                        fontSize:
                                          cStyle.tTextViewTableHeaderFontSizeOn,
                                        fontWeight:
                                          cStyle.tTextViewTableHeaderFontWeightOn,
                                      }),
                                      className: "hc",
                                    }),
                                    className: "hc",
                                    key: "0",
                                  }),
                                  ui.TableCell({
                                    verticalAlignment:
                                      ui.TableCellVerticalAlignment.middle,
                                    child: TextView({
                                      data: "Phone Type",
                                      style: new ui.TextStyle({
                                        fontFamily:
                                          cStyle.tTextViewTableHeaderFontFamilyOn,
                                        color:
                                          cStyle.tTextViewTableHeaderColorOn,
                                        fontSize:
                                          cStyle.tTextViewTableHeaderFontSizeOn,
                                        fontWeight:
                                          cStyle.tTextViewTableHeaderFontWeightOn,
                                      }),
                                      className: "hc",
                                    }),
                                    className: "hc",
                                    key: "1",
                                  }),
                                  ui.TableCell({
                                    verticalAlignment:
                                      ui.TableCellVerticalAlignment.middle,
                                    child: TextView({
                                      data: "Location",
                                      style: new ui.TextStyle({
                                        fontFamily:
                                          cStyle.tTextViewTableHeaderFontFamilyOn,
                                        color:
                                          cStyle.tTextViewTableHeaderColorOn,
                                        fontSize:
                                          cStyle.tTextViewTableHeaderFontSizeOn,
                                        fontWeight:
                                          cStyle.tTextViewTableHeaderFontWeightOn,
                                      }),
                                      className: "hc",
                                    }),
                                    className: "hc",
                                    key: "2",
                                  }),
                                ],
                                className: "xc0 hc",
                                key: "0",
                              }),
                              item.phoneNumbers.isNotEmpty
                                ? item.phoneNumbers.expand((forItem) => [
                                    ui.TableRow({
                                      children: [
                                        ui.TableCell({
                                          verticalAlignment:
                                            ui.TableCellVerticalAlignment
                                              .middle,
                                          child: TextView({
                                            data: forItem.phoneNumber,
                                            softWrap:
                                              cStyle.tTextViewTableCellTextSoftWrapOn,
                                            style: new ui.TextStyle({
                                              fontFamily:
                                                cStyle.tTextViewTableCellTextFontFamilyOn,
                                              color:
                                                cStyle.tTextViewTableCellTextColorOn,
                                              fontSize:
                                                cStyle.tTextViewTableCellTextFontSizeOn,
                                            }),
                                            className: "hc",
                                          }),
                                          className: "hc",
                                          key: "0",
                                        }),
                                        ui.TableCell({
                                          verticalAlignment:
                                            ui.TableCellVerticalAlignment
                                              .middle,
                                          child: TextView({
                                            data: forItem.phoneType,
                                            softWrap:
                                              cStyle.tTextViewTableCellTextSoftWrapOn,
                                            style: new ui.TextStyle({
                                              fontFamily:
                                                cStyle.tTextViewTableCellTextFontFamilyOn,
                                              color:
                                                cStyle.tTextViewTableCellTextColorOn,
                                              fontSize:
                                                cStyle.tTextViewTableCellTextFontSizeOn,
                                            }),
                                            className: "hc",
                                          }),
                                          className: "hc",
                                          key: "1",
                                        }),
                                        ui.TableCell({
                                          verticalAlignment:
                                            ui.TableCellVerticalAlignment
                                              .middle,
                                          child: TextView({
                                            data: forItem.location,
                                            softWrap:
                                              cStyle.tTextViewTableCellTextSoftWrapOn,
                                            style: new ui.TextStyle({
                                              fontFamily:
                                                cStyle.tTextViewTableCellTextFontFamilyOn,
                                              color:
                                                cStyle.tTextViewTableCellTextColorOn,
                                              fontSize:
                                                cStyle.tTextViewTableCellTextFontSizeOn,
                                            }),
                                            className: "hc",
                                          }),
                                          className: "hc",
                                          key: "2",
                                        }),
                                      ],
                                      className: "xcaf hc",
                                      key: forItem?.ident,
                                    }),
                                  ])
                                : [],
                            ],
                            className: "x4b3 hc h",
                            key: "0",
                          }),
                          item.phoneNumbers.isEmpty
                            ? ui.Column({
                                mainAxisAlignment: ui.MainAxisAlignment.center,
                                children: [
                                  TextView({
                                    data: "No Phone Numbers Found",
                                    style: new ui.TextStyle({
                                      fontWeight: ui.FontWeight.bold,
                                      fontSize: 16,
                                    }),
                                    className: "x8fe hc",
                                    key: "0",
                                  }),
                                ],
                                className: "x196 hc",
                              })
                            : [],
                        ],
                        className: "x210 hc vc h",
                        key: "0",
                      }),
                      ui.Column({
                        mainAxisAlignment: ui.MainAxisAlignment.start,
                        crossAxisAlignment: ui.CrossAxisAlignment.start,
                        children: [
                          ui.Table({
                            defaultColumnWidth: new ui.FlexColumnWidth(1),
                            children: [
                              ui.TableRow({
                                children: [
                                  ui.TableCell({
                                    verticalAlignment:
                                      ui.TableCellVerticalAlignment.middle,
                                    child: TextView({
                                      data: "Email",
                                      style: new ui.TextStyle({
                                        fontFamily:
                                          cStyle.tTextViewTableHeaderFontFamilyOn,
                                        color:
                                          cStyle.tTextViewTableHeaderColorOn,
                                        fontSize:
                                          cStyle.tTextViewTableHeaderFontSizeOn,
                                        fontWeight:
                                          cStyle.tTextViewTableHeaderFontWeightOn,
                                      }),
                                      className: "hc",
                                    }),
                                    className: "hc",
                                    key: "0",
                                  }),
                                ],
                                className: "x44a hc",
                                key: "0",
                              }),
                              item.emails.isNotEmpty
                                ? item.emails.expand((forItem) => [
                                    ui.TableRow({
                                      children: [
                                        ui.TableCell({
                                          verticalAlignment:
                                            ui.TableCellVerticalAlignment
                                              .middle,
                                          child: TextView({
                                            data: forItem,
                                            softWrap:
                                              cStyle.tTextViewTableCellTextSoftWrapOn,
                                            style: new ui.TextStyle({
                                              fontFamily:
                                                cStyle.tTextViewTableCellTextFontFamilyOn,
                                              color:
                                                cStyle.tTextViewTableCellTextColorOn,
                                              fontSize:
                                                cStyle.tTextViewTableCellTextFontSizeOn,
                                            }),
                                            className: "hc",
                                          }),
                                          className: "hc",
                                          key: "0",
                                        }),
                                      ],
                                      className: "x15c hc",
                                      key: forItem?.toString(),
                                    }),
                                  ])
                                : [],
                            ],
                            className: "x795 hc h",
                            key: "0",
                          }),
                          item.emails.isEmpty
                            ? ui.Column({
                                mainAxisAlignment: ui.MainAxisAlignment.center,
                                children: [
                                  TextView({
                                    data: "No Emails found",
                                    style: new ui.TextStyle({
                                      fontWeight: ui.FontWeight.bold,
                                      fontSize: 16,
                                    }),
                                    className: "x533 hc",
                                    key: "0",
                                  }),
                                ],
                                className: "x442 hc",
                              })
                            : [],
                        ],
                        className: "x3514 hc vc h",
                        key: "1",
                      }),
                    ],
                    className: "x80e hc h",
                    key: "1",
                  }),
                ],
                className: "x009 hc h",
              }),
            }),
            key: item?.ident,
            className: "x9de hc h",
          }),
        ]),
      ],
      className: ui.join(
        this.props.className,
        "ResponseRelativesView xd63 hc h"
      ),
      ...copyBaseUIProps(this.props),
    });
  }
}
export default function ResponseRelativesView(
  props: ResponseRelativesViewProps
) {
  return React.createElement(
    _ResponseRelativesViewState,
    { ..._ResponseRelativesViewState.defaultProps, ...props },
    ListWrapper.fromInput<Relative>(props.obj, "obj")
  );
}
